import React from 'react';
import { formatText } from 'core/i18n';
import { InfoTooltip } from 'components/tooltip/tooltip';
import PropTypes from 'prop-types';
import { JoinHolderRow } from './joinHolderRow';
import './joinHolderTable.scss';
export const JoinHolderTable = ({ joinHolders, onClickTooltip }) => {
    return (
        <div className={'joinHolder-table'}>
            <div className={'joinHolder-table-header'}>
                <span>{formatText('deposit-intervationTitle')}</span>
                <div className="tooltip-wrapper">
                    <InfoTooltip triggerEvent={onClickTooltip} text={formatText('deposit-intervationTooltip')} />
                </div>
            </div>
            <div className={'joinHolder-table-content'}>
                {joinHolders.map((joinHolder, index) => (
                    <JoinHolderRow name={joinHolder.fullName} type={joinHolder.formattedAccountType} key={index} />
                ))}
            </div>
        </div>
    );
};

JoinHolderTable.propTypes = {
    joinHolders: PropTypes.array,
    onClickTooltip: PropTypes.func,
};
